// eslint-disable */
const validateField = (field, fieldName) => {
  let error = '';
  if (!field) {
      error = `${fieldName} Cannot be Empty`;
  }
  return error;
};

export const opdValidation = (values) => {
  let errors = {};
  let isValid = true;

  errors.departmentId = validateField(values.departmentId, 'Department');
  
  errors.doctorId = validateField(values.doctorId, 'Doctor');
  // errors.referralId= validateField(values.referralId, 'Referral');
  // Check if any errors were found
  for (const key in errors) {
      if (errors[key]) {
          isValid = false;
          break;
      }
  }

  return { errors, isValid };
};

  